import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Une erreur est survenue. Veuillez réessayer.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const CATEGORIES = ["Tous", "Citadine", "Berline", "Break", "SUV / 4x4", "Monospace"];
export const TRANSMISSIONS = ["Toutes", "Automatique", "Manuelle"];
export const FUELS = ["Tous", "Diesel", "Essence", "Hybride", "Électrique"];

export const PLANS = [
  {
    key: "standard",
    name: "Standard",
    tagline: "Je veux être visible",
    color: "#3A506B",
    features: [
      "Présence sur la plateforme",
      "Profil agence professionnel",
      "Présentation des véhicules & photos",
      "Tarifs & conditions de location",
      "Disponibilités",
      "Réception des demandes clients",
    ],
  },
  {
    key: "pro",
    name: "Pro",
    tagline: "Je veux gérer mon activité",
    color: "#006233",
    popular: true,
    features: [
      "Tout le plan Standard",
      "Calendrier des véhicules & planning",
      "Réservations & blocages des véhicules",
      "Suivi des locations",
      "Notifications en temps réel",
    ],
  },
  {
    key: "premium",
    name: "Premium",
    tagline: "Je veux développer mon activité",
    color: "#C1272D",
    features: [
      "Tout le plan Pro",
      "Fichier clients & prospects",
      "Facturation & suivi des encaissements",
      "Préparation des contrats",
      "Statistiques & chiffre d'affaires",
      "Taux d'utilisation du parc",
    ],
  },
];

// Prix mensuel par véhicule (MAD) selon la taille du parc
export const PRICING_TABLE = [
  { range: "1 à 3 véhicules", min: 1, max: 3, standard: 100, pro: 115, premium: 150 },
  { range: "4 à 6 véhicules", min: 4, max: 6, standard: 95, pro: 110, premium: 145 },
  { range: "7 à 9 véhicules", min: 7, max: 9, standard: 90, pro: 105, premium: 140 },
  { range: "10 véhicules et +", min: 10, max: 9999, standard: 85, pro: 100, premium: 135 },
];

export function unitPrice(planKey, fleetSize) {
  const row = PRICING_TABLE.find((r) => fleetSize >= r.min && fleetSize <= r.max) || PRICING_TABLE[0];
  return row[planKey];
}
